export const ROUTES = {
  home: '/',

  login: '/login',
  unauthorized: '/unauthorized',

  search: '/search',
  dashboard: '/dashboard',

  visits: '/visits',
  visitsMap: '/visits/map',
  visitsTimeline: '/visits/timeline',
  visitsProvider: '/visits/provider',

  claims: '/claims',
  feeSchedule: '/fee-schedule',

  providers: '/providers',
  providerCreate: '/providers/create',

  pods: '/pods',

  patients: '/patients',

  accounts: '/accounts',

  concierge: '/partners',
  agency: '/partners/agency',

  onSiteManager: '/on-site-manager',
  onSiteManagerCreatePartner: '/on-site-manager/partners/create',
  onSiteManagerEditPartner: '/on-site-manager/partners/:id',
  onSiteManagerAppointments: '/on-site-manager/appointments',
  onSiteManagerPartners: '/on-site-manager/partners',
  onSiteManagerOnSites: '/on-site-manager/onsites',
  // onSiteManagerEditOnSite: '/on-site-manager/onsites/:id',

  createVisit: '/create-visit',
  toolOptimize: '/optimize',

  toolInsurance: '/tool/insurance',
  toolInsuranceTester: '/tool/insurance-tester',
  toolAdmin: '/tool/admin',
  insuranceRules: '/insurance/rules',

  plans: '/plans/add',

  scheduling: '/scheduling',

  markets: '/markets',
  marketMap: '/markets-map',

  webhooks: '/webhooks',
};
